import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getOfferProducts,
  getOfferProductsV3,
  getProductTypeCombinations,
  putProductsOrder,
  putProductsOrderV2,
  submitBusinessLead,
  submitCommercialOpportunity,
  getInterruptions,
  getDiscontinueReasons,
  sendOfferUsagesFeatures,
  sendOfferByMail,
  recordOfferEvent,
} from '../services/ProductsPublicService';

export const useProductsPublicGetOfferProducts = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getOfferProducts, 'requestBody', 'data'),
      'data',
      'postalCode',
      'houseNumber',
      'houseNumberSuffix',
      'gasValue',
      'electricityNormalValue',
      'electricityLowValue',
      'electricityRedeliveryHigh',
      'electricityRedeliveryLow',
      'electricityRedeliveryTotal',
      'warmthElectricity',
      'warmthWater',
      'isMkb',
      'offerType',
      'voucherCode',
      'campaignCode',
      'actionCode',
      'products',
      'contractStartDate',
      'includeRentalProducts',
      'urgent',
      'ci',
      'movingCustomer',
      'isResidence',
      'allowDynamicOrHybridOnly',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'postalCode',
          'houseNumber',
          'houseNumberSuffix',
          'gasValue',
          'electricityNormalValue',
          'electricityLowValue',
          'electricityRedeliveryHigh',
          'electricityRedeliveryLow',
          'electricityRedeliveryTotal',
          'warmthElectricity',
          'warmthWater',
          'isMkb',
          'offerType',
          'voucherCode',
          'campaignCode',
          'actionCode',
          'products',
          'contractStartDate',
          'includeRentalProducts',
          'urgent',
          'ci',
          'movingCustomer',
          'isResidence',
          'allowDynamicOrHybridOnly',
        ],
      },
    ],
  },
);

export const useProductsPublicGetOfferProductsV3 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getOfferProductsV3, 'requestBody', 'data'),
      'data',
      'address',
      'usages',
      'isMkb',
      'offerType',
      'voucherCode',
      'campaignCode',
      'actionCode',
      'products',
      'preferredContractStartDate',
      'includeRentalProducts',
      'urgent',
      'movingCustomer',
      'isResidence',
      'allowDynamicOrHybridOnly',
      'promotionCode',
      'usageSpecified',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'address',
          'usages',
          'isMkb',
          'offerType',
          'voucherCode',
          'campaignCode',
          'actionCode',
          'products',
          'preferredContractStartDate',
          'includeRentalProducts',
          'urgent',
          'movingCustomer',
          'isResidence',
          'allowDynamicOrHybridOnly',
          'promotionCode',
          'usageSpecified',
        ],
      },
    ],
  },
);

export const useProductsPublicGetProductTypeCombinations = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getProductTypeCombinations, 'requestBody', 'data'),
      'data',
      'postalCode',
      'houseNumber',
      'houseNumberSuffix',
      'gasValue',
      'electricityNormalValue',
      'electricityLowValue',
      'electricityRedeliveryHigh',
      'electricityRedeliveryLow',
      'electricityRedeliveryTotal',
      'warmthElectricity',
      'warmthWater',
      'isMkb',
      'offerType',
      'voucherCode',
      'campaignCode',
      'actionCode',
      'products',
      'contractStartDate',
      'includeRentalProducts',
      'urgent',
      'ci',
      'movingCustomer',
      'isResidence',
      'allowDynamicOrHybridOnly',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'postalCode',
          'houseNumber',
          'houseNumberSuffix',
          'gasValue',
          'electricityNormalValue',
          'electricityLowValue',
          'electricityRedeliveryHigh',
          'electricityRedeliveryLow',
          'electricityRedeliveryTotal',
          'warmthElectricity',
          'warmthWater',
          'isMkb',
          'offerType',
          'voucherCode',
          'campaignCode',
          'actionCode',
          'products',
          'contractStartDate',
          'includeRentalProducts',
          'urgent',
          'ci',
          'movingCustomer',
          'isResidence',
          'allowDynamicOrHybridOnly',
        ],
      },
    ],
  },
);

export const useProductsPublicPutProductsOrder = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(putProductsOrder, 'requestBody', 'data'),
      'data',
      'productOffers',
      'customer',
      'deliveryAddress',
      'processingType',
      'configuration',
      'isResidence',
      'referenceId',
      'desiredAdvancePaymentAmount',
      'b2BCustomerCategoryCriteria',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'productOffers',
          'customer',
          'deliveryAddress',
          'processingType',
          'configuration',
          'isResidence',
          'referenceId',
          'desiredAdvancePaymentAmount',
          'b2BCustomerCategoryCriteria',
        ],
      },
    ],
  },
);

export const useProductsPublicPutProductsOrderV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(putProductsOrderV2, 'requestBody', 'data'),
      'data',
      'productOffers',
      'customer',
      'deliveryAddress',
      'processingType',
      'configuration',
      'isResidence',
      'referenceId',
      'desiredAdvancePaymentAmount',
      'b2BCustomerCategoryCriteria',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'productOffers',
          'customer',
          'deliveryAddress',
          'processingType',
          'configuration',
          'isResidence',
          'referenceId',
          'desiredAdvancePaymentAmount',
          'b2BCustomerCategoryCriteria',
        ],
      },
    ],
  },
);

export const useProductsPublicSubmitBusinessLead = createMutationHook(
  collapseParams(collapseParams(submitBusinessLead, 'requestBody', 'data'), 'data', 'emailAddress'),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['emailAddress'] },
    ],
  },
);

export const useProductsPublicSubmitCommercialOpportunity = createMutationHook(
  collapseParams(
    collapseParams(submitCommercialOpportunity, 'requestBody', 'data'),
    'data',
    'companyName',
    'chamberOfCommerceNumber',
    'contactPerson',
    'deliveryAddress',
    'requestedStartDate',
    'gasEstimatedYearlyUsage',
    'electricityEstimatedYearlyUsage',
    'additionalInfo',
    'campaignCode',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'companyName',
          'chamberOfCommerceNumber',
          'contactPerson',
          'deliveryAddress',
          'requestedStartDate',
          'gasEstimatedYearlyUsage',
          'electricityEstimatedYearlyUsage',
          'additionalInfo',
          'campaignCode',
        ],
      },
    ],
  },
);

export const useProductsPublicGetInterruptions = createDCHook(
  'getInterruptions',
  collapseDataFromCall(getInterruptions),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useProductsPublicGetDiscontinueReasons = createDCHook(
  'getDiscontinueReasons',
  collapseDataFromCall(getDiscontinueReasons),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useProductsPublicSendOfferUsagesFeatures = createMutationHook(
  collapseParams(collapseParams(sendOfferUsagesFeatures, 'requestBody', 'data'), 'data', 'offerUsages', 'address'),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['offerUsages', 'address'] },
    ],
  },
);

export const useProductsPublicSendOfferByMail = createMutationHook(
  collapseParams(
    collapseParams(sendOfferByMail, 'requestBody', 'data'),
    'data',
    'emailAddress',
    'shoppingBasketId',
    'url',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['emailAddress', 'shoppingBasketId', 'url'] },
    ],
  },
);

export const useProductsPublicRecordOfferEvent = createMutationHook(
  collapseParams(
    collapseParams(recordOfferEvent, 'requestBody', 'data'),
    'data',
    'postalCode',
    'houseNumber',
    'houseNumberSuffix',
    'electricityUsagePeak',
    'electricityUsageOffPeak',
    'electricityRedelivery',
    'gasUsage',
    'offerGroup',
    'offers',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'postalCode',
          'houseNumber',
          'houseNumberSuffix',
          'electricityUsagePeak',
          'electricityUsageOffPeak',
          'electricityRedelivery',
          'gasUsage',
          'offerGroup',
          'offers',
        ],
      },
    ],
  },
);
